module.exports = __webpack_public_path__ + "img/1481765701.17db845b.jpg";